import React, { useEffect, useState } from "react";
import { Button, Form, Modal } from "react-bootstrap";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import upload from '../../assets/images/Paper Upload.png'
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import AsyncSelect from "react-select/async";
import toast from 'react-hot-toast'
import { getCategoryListingPaginate, getManufacturesListingPaginate, getSubCategoryListingPaginate } from "../../api/context/manufacturer";
import { IoIosRemoveCircle } from "react-icons/io";
import { IoIosAddCircle } from "react-icons/io";
import { BsX } from "react-icons/bs";



const customStyles = {
  control: (provided) => ({
    ...provided,
    border: " 1px solid #a7a7a7",
    padding: "6px",
  }),
};

const CreatePromoCodes = ({
  show,
  handleClose,
  formik,
  category,
  setCategory,
  subcategory,
  setSubCategory,
  selectedpromocode,
  loading,
  loadOptionsInventory,
  inventory,
  onBuyChange,
  onGetProduct,
  onInventoryChange,
  offer,
  onDate,
  handleImageChange,
  onBuyQuantityChange,
  onGetQuantityChange,
  // onManufactureChange,
  preImage,
  onVendor,
  // onNumberChange,
  changeNumber,
  numberShow,
  // vendorDetails
}) => {
  const [offerType, setOfferType] = useState("");
  const [manufacture, setManufacture] = useState()
  const [offerList, setOfferList] = useState()
  const [buyQuantity, setBuyQuantity] = useState()
  const [vendorDetails, setVendorDetails] = useState([])


  const [excludeVendorError, setExcludeVendorError] = useState(false); // Validation error state
  const [excludeVendorPage, setExcludeVendorPage] = useState(1); // Pagination current page
  const [excludeVendorHasMore, setExcludeVendorHasMore] = useState(true); // Pagination flag for more data
  let excludeVendorTypingTimer; // ADD: Timer for search debouncing
  // In CreatePromoCodes.js - you need to initialize from formik values
  const [excludeVendors, setExcludeVendors] = useState(formik.values.selectedExcludeVendors || []);




  const user = JSON.parse(localStorage.getItem('user'));


  // ADD: Function to load vendors for exclude vendors dropdown
  const loadOptionsExcludeVendors = (inputValue) => {
    return new Promise((resolve, reject) => {
      clearTimeout(excludeVendorTypingTimer);
      excludeVendorTypingTimer = setTimeout(() => {
        if (inputValue.length >= 3) {
          getManufacturesListingPaginate({
            page: excludeVendorPage,
            limit: 10,
            search: inputValue
          })(response => {
            if (response?.statusCode === 200) {
              resolve(response?.results || []);
            } else {
              resolve([]);
            }
          });
        } else {
          resolve([]);
        }
      }, 300);
    });
  };

  // ADD: Function to handle exclude vendor selection
  const onExcludeVendorChange = (selectedOptions) => {
    const excludeVendorIds = selectedOptions ? selectedOptions.map(vendor => vendor.value) : [];

    formik.setValues({
      ...formik.values,
      excludeVendorIds: excludeVendorIds,
      selectedExcludeVendors: selectedOptions || []
    });

    setExcludeVendorError(false);
  };

  // ADD: Function to remove single exclude vendor
  const removeExcludeVendor = (vendorToRemove) => {
    const updatedVendors = excludeVendors.filter(vendor => vendor.value !== vendorToRemove.value);
    setExcludeVendors(updatedVendors);

    const excludeVendorIds = updatedVendors.map(vendor => vendor.value);
    formik.setValues({
      ...formik.values,
      excludeVendorIds: excludeVendorIds,
      selectedExcludeVendors: updatedVendors
    });
  };

  // ADD: Function to handle infinite scroll for exclude vendors
  const handleExcludeVendorMenuScrollToBottom = () => {
    if (excludeVendorHasMore) {
      const nextPage = excludeVendorPage + 1;
      setExcludeVendorPage(nextPage);

      // You might want to load more vendors here if needed
      // This would depend on your API pagination implementation
    }
  };

  // ADD: Validation for exclude vendors (example)
  const validateExcludeVendors = () => {
    // Check if any vendor is both included and excluded
    const includedVendorIds = formik.values.vendorIds || [];
    const excludedVendorIds = formik.values.excludeVendorIds || [];

    const hasConflict = includedVendorIds.some(vendorId =>
      excludedVendorIds.includes(vendorId)
    );

    if (hasConflict) {
      setExcludeVendorError(true);
      return false;
    }

    setExcludeVendorError(false);
    return true;
  };

  // ADD: Call validation when vendors or exclude vendors change
  useEffect(() => {
    if (formik.values.vendorIds?.length > 0 || formik.values.excludeVendorIds?.length > 0) {
      validateExcludeVendors();
    }
  }, [formik.values.vendorIds, formik.values.excludeVendorIds]);

  // Add this useEffect in CreatePromoCodes.js
  useEffect(() => {
    if (formik.values.selectedExcludeVendors) {
      setExcludeVendors(formik.values.selectedExcludeVendors);
    }
  }, [formik.values.selectedExcludeVendors]);



  // const inputVendorId = vendorDetails.map((li)=>li.value)
  // const sameValueVendors = inventory.findIndex(
  //   (item) => item.vendorId === inputVendorId)
  //   console.log(inventory[sameValueVendors]);
  console.log(user);
  const handleOfferChange = (value) => {
    console.log(value, "value");
    setOfferType(value);
  };
  console.log(inventory);
  const buyAndGetFree = offer?.map((li) => li.value)
  console.log(buyAndGetFree, "333333");
  const value = buyAndGetFree[0]
  console.log(value);

  useEffect(() => {
    const offersOf = offer.map((li) => (
      <option value={li?.value}>{li?.value}</option>
    ))
    setOfferList(offersOf)
  }, [])

  const onInventory = (item) => {

    console.log(inventory.filter((li) => li.vendorId === item));
    return inventory.filter((li) => li.vendorId === item)
  }

  const onSubcategory = (item) => {
    return subcategory.filter((li) => li.value === item)
  }
  console.log(inventory);
  console.log(subcategory);
  // const handleImageChange = async (e) => {

  //   const file = e?.target?.files[0];
  //   const maxSizeInBytes = 2 * 1024 * 1024;



  //     if (file.size > maxSizeInBytes) {
  //         toast.error("File size exceeds 2 MB limit", 'error')
  //         e.target.value = null;
  //         return;
  //     }
  //     const response = await imageToBase64(URL.createObjectURL(file));
  //     formik.setValues({
  //         ...formik.values,
  //         image: response,
  //         img_view: 'data:image/jpeg;base64,' + response,
  //     });
  // } 

  //   const onManufactureChange = (selectedOption) => {

  //     // const sameValueVendors = inventory.findIndex(
  //     //   (item) => item.vendorId === selectedOption.value)
  //     //   console.log(inventory[sameValueVendors]);
  //     const vendorId = selectedOption.map((li)=>li.value)
  //     formik.setValues({
  //       ...formik.values,
  //       vendorIds: selectedOption ? vendorId : '',
  //       selectedVendors: selectedOption,
  //     });
  // setVendorDetails(selectedOption)

  //   }; 
  console.log(formik.values.vendors);
  const onManufactureChange = (selectedOption) => {

    const oldVendorsList = [...formik.values.vendors]
    const freeItems = [...formik.values.freeItems]

    console.log(selectedOption);
    const vendor_id = selectedOption.map((li) => li.value)
    let freeItemList = freeItems
    let vendorList = oldVendorsList
    selectedOption.forEach(item => {
      if ((oldVendorsList.length === 0) && (formik.values.offerType === "Buy and Get Free")) {
        vendorList.push({
          vendorId: item.value,
          vendorLabel: item.label,
          buy_quantity: "",
          get_quantity: "",
          items: [{
            selectedBuyProduct: "",
            selectedGetProduct: "",
            get_product: "",
            buy_product: ""
          }]
        });


        freeItemList.push(
          {

            vendorId: item.value,
            vendorLabel: item.label,
            minimum_cart_value: "",
            product_id: "",
            selectedProduct: ""

          }
        )

      } else if ((!oldVendorsList.find(i => i.vendorId === item.value)) && formik.values.offerType === "Buy and Get Free") {
        vendorList.push({
          vendorId: item.value,
          vendorLabel: item.label,
          buy_quantity: "",
          get_quantity: "",
          items: [{
            selectedBuyProduct: "",
            selectedGetProduct: "",
            get_product: "",
            buy_product: ""
          }]
        });

        freeItemList.push(
          {

            vendorId: item.value,
            vendorLabel: item.label,
            minimum_cart_value: "",
            product_id: "",
            selectedProduct: ""

          }
        )

      } else if ((oldVendorsList.length === 0) && (formik.values.offerType === "Flat Amount on Minimum Cart Value" || formik.values.offerType === "Discount in Percentage on Minimum Cart Value")) {
        vendorList.push({
          vendorLabel: item.label,
          vendorId: item.value,
          amount: "",
          minimum_cart_value: ""
        });
        freeItemList.push(
          {

            vendorId: item.value,
            vendorLabel: item.label,
            minimum_cart_value: "",
            product_id: "",
            selectedProduct: ""

          }
        )

      } else if ((!oldVendorsList.find(i => i.vendorId === item.value)) && (formik.values.offerType === "Flat Amount on Minimum Cart Value" || formik.values.offerType === "Discount in Percentage on Minimum Cart Value")) {
        vendorList.push({
          vendorLabel: item.label,
          vendorId: item.value,
          amount: "",
          minimum_cart_value: ""
        });

        freeItemList.push(
          {

            vendorId: item.value,
            vendorLabel: item.label,
            minimum_cart_value: "",
            product_id: "",
            selectedProduct: ""

          }
        )

      }


      // else  if(oldVendorsList.length==0 && formik.values.offerType=="Flat Amount on Category or Subcategory"||"Discount in Percentage on Category or Subcategory"){
      //     vendorList.push(
      //       {

      //         vendorId: item.value,
      //         vendorLabel:item.label,
      //         buy_quantity: "",
      //         get_quantity: "",
      //         items: [
      //             {
      //               selectedBuyProduct:"",
      //               selectedGetProduct:[],
      //                 get_product: [],
      //                 buy_product:""
      //             }
      //         ]
      //     }
      //     )
      //   }
      //   else if(oldVendorsList.some(i=>i.vendorId!=item.value && formik.values.offerType=="Flat Amount on Category or Subcategory"||"Discount in Percentage on Category or Subcategory")){
      //     vendorList.push(
      //       {
      //         selectedBuyProduct:"",
      //         slectedGetProduct:[],
      //         vendorId: item.value,
      //         vendorLabel:item.label,
      //         buy_quantity: "",
      //         get_quantity: "",
      //         items: [
      //             {
      //               selectedBuyProduct:"",
      //               selectedGetProduct:[],
      //                 get_product:[],
      //                 buy_product:""
      //             }
      //         ]
      //     }
      //     )
      //   }
      if (freeItems.length == 0 && formik.values.offerType == "Free Item on Minimum Cart Value") {

        console.log(freeItems);



        freeItemList.push(
          {

            vendorId: item.value,
            vendorLabel: item.label,
            minimum_cart_value: "",
            product_id: "",
            selectedProduct: ""

          }
        )
        vendorList.push({
          vendorId: item.value,
          vendorLabel: item.label,
          buy_quantity: "",
          get_quantity: "",
          items: [{
            selectedBuyProduct: "",
            selectedGetProduct: "",
            get_product: "",
            buy_product: ""
          }]
        });;
      }
      else if (!freeItems.some(i => i.vendorId === item.value) && (formik.values.offerType == "Free Item on Minimum Cart Value")) {
        freeItemList.push(
          {
            vendorId: item.value,
            vendorLabel: item.label,
            minimum_cart_value: "",
            product_id: "",
            selectedProduct: ""
          }
        )
        vendorList.push({
          vendorId: item.value,
          vendorLabel: item.label,
          buy_quantity: "",
          get_quantity: "",
          items: [{
            selectedBuyProduct: "",
            selectedGetProduct: "",
            get_product: "",
            buy_product: ""
          }]
        });;
      }



      //  console.log(vendorList.filter((li)=>li.vendorLabel=== item.label));

    })

    freeItemList = freeItemList.filter(v => vendor_id.includes(v.vendorId))
    vendorList = vendorList.filter(v => vendor_id.includes(v.vendorId))

    // const productValue = {vendorId:vendor_id,buy_quantity:formik.values.buy_n,get_quantity:formik.values.get_n, items  }  
    // formik.values.offerType==="Free Item on Minimum Cart Value"?   formik.setValues({
    //     ...formik.values,
    //     freeItems:freeItemList,
    //     selectedVendors:selectedOption,
    //     vendorIds:vendor_id

    //   }):
    formik.setValues({
      ...formik.values,

      vendors: vendorList,
      selectedVendors: selectedOption,
      freeItems: freeItemList,
      vendorIds: vendor_id
    })
    setVendorDetails(selectedOption)
  }

  const addNewItem = (index) => {

    console.log("haii");
    const oldIVendor = [...formik.values.vendors]
    const vendorLists = oldIVendor
    if (oldIVendor[index].items) {
      vendorLists[index].items.push(
        {
          selectedBuyProduct: "",
          selectedGetProduct: [],
          get_product: [],
          buy_product: ""
        }
      )
    }

    formik.setValues({
      ...formik.values,
      vendors: vendorLists
    })



  }
  console.log(formik.values.vendors);

  const removeItem = (e, index, indexToRemove) => {

    let updatedFeatures = [...formik.values.vendors];
    if (indexToRemove > 0) {
      updatedFeatures[index].items.splice(indexToRemove, 1);
    }// Remove feature at the specified index
    formik.setValues({
      ...formik.values,
      vendors: updatedFeatures,
    });
  };

  const amountHandler = (e, index) => {
    const vendorsList = [...formik.values.vendors]
    vendorsList[index].amount = e
    formik.setValues(
      {
        ...formik.values,
        vendors: vendorsList,
        amount: e ? e : ""
      }
    )
  }

  const minimumCartvalueHandler = (e, index) => {
    const vendorsList = [...formik.values.vendors]
    vendorsList[index].minimum_cart_value = e
    formik.setValues(
      {
        ...formik.values,
        vendors: vendorsList,
        minimum_cart_value: e
      }
    )
  }

  const minimumCartonFreeItemHandler = (e, index) => {
    const freeItems = [...formik.values.freeItems]
    freeItems[index].minimum_cart_value = e
    formik.setValues({
      ...formik.values,
      freeItems: freeItems,
      minimum_cart_value: e ? e : ""
    })
  }

  const inventoryChange = (e, index) => {
    console.log(e);
    const freeItemsValue = [...formik.values.freeItems]
    freeItemsValue[index].product_id = e?.value ? e.value : ""
    freeItemsValue[index].selectedProduct = e ? e : ""
    formik.setValues({
      ...formik.values,
      freeItems: freeItemsValue,
      selectedInventory: e ? e : ""

    })
  }

  console.log();

  let typingTimer
  const loadOptionsManufacture = inputValue => {
    return new Promise((resolve, reject) => {
      clearTimeout(typingTimer);
      typingTimer = setTimeout(() => {
        if (inputValue.length >= 3) {
          getManufacturesListingPaginate({ page: 1, limit: 10, search: inputValue })(response => {
            console.log(response)
            if (response?.statusCode == 200) {
              console.log(response?.results)
              resolve(response?.results);
              setManufacture(response?.results)
            } else {
            }
          })
        }
        else {
          resolve([]);
        }

      }, 300);
    });
  };

  const loadOptionsCategory = inputValue => {
    return new Promise((resolve, reject) => {
      clearTimeout(typingTimer);
      typingTimer = setTimeout(() => {
        if (inputValue.length >= 3) {
          getCategoryListingPaginate({ page: 1, limit: 10, search: inputValue })(response => {
            console.log(response)
            if (response?.statusCode == 200) {
              console.log(response?.results)
              resolve(response?.results);
              setCategory(response?.results)
            } else {
            }
          })
        }
        else {
          resolve([]);
        }

      }, 300);
    });
  };

  const loadOptionsSubCategory = (inputValue, categoryId) => {
    return new Promise((resolve, reject) => {
      clearTimeout(typingTimer);
      typingTimer = setTimeout(() => {
        if (inputValue.length >= 3) {
          getSubCategoryListingPaginate({ page: 1, limit: 10, search: inputValue, categoryIds: [categoryId] })(response => {
            console.log(response)
            if (response?.statusCode == 200) {
              console.log(response?.results)
              resolve(response?.results);
              setSubCategory(response?.results)
            } else {
            }
          })
        }
        else {
          resolve([]);
        }

      }, 300);
    });
  };

  const onCategoryChange = (categoryValue) => {
    // console.log(selectedOption, 'selectedOption');
    const valueOfCategories = categoryValue.map((li) => li.value)
    // formik.setValues({
    //     ...formik.values,
    //     subCategoryId: selectedOption ? selectedOption.value : '',
    //     selectedCategory: selectedOption,
    //     category_ids:selectedOption?value:[]
    // });
    const categoryList = [...formik.values.categories]
    let categoryLists = categoryList
    categoryValue.forEach(item => {
      if (categoryLists.length === 0) {
        categoryLists.push({
          categoryId: item.value,
          categoryLabel: item.label,
          subcategories: [

          ],
          selectedSubSubCategories: []
        })
      }
      else if (!categoryLists.some(categoryItem => categoryItem.categoryId === item.value)) {
        categoryLists.push({
          categoryId: item.value,
          categoryLabel: item.label,
          subcategories: [

          ],
          selectedSubSubCategories: []

        })
      }
    })

    categoryLists = categoryLists.filter(v => valueOfCategories.includes(v.categoryId))


    formik.setValues({
      ...formik.values,
      categories: categoryLists,
      category_ids: valueOfCategories,
      selectedCategory: categoryValue
    })
  };


  const onSubCategoryChange = (selectedOption, index) => {
    const subValue = selectedOption.map((li) => li.value)
    const itemList = [...formik.values?.categories]
    console.log(subValue);
    itemList[index].subcategories = subValue
    itemList[index].selectedSubSubCategories = selectedOption

    formik.setValues({
      ...formik.values,
      categories: itemList,
      subSubCategoryId: selectedOption ? selectedOption.value : '',
      selectedSubCategory: selectedOption,
      sub_category_ids: selectedOption ? subValue : []
    });
  };

  const categoryAmountHAndler = (e) => {
    formik.setValues({
      ...formik.values,
      amount: e
    })
  }

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    const trimmedValue = value.replace(/^\s+/, '');
    formik.setFieldValue(name, trimmedValue);
  };

  useEffect(() => {
    const findCommonElement = (array1, array2) => {
      return array1.find(element => array2.some(li => li.value === element.vendorId));;
    };

    console.log(findCommonElement(inventory, vendorDetails));
  }, [inventory, vendorDetails])

  useEffect(() => {
    getManufacturesListingPaginate({ page: 1, limit: 10, search: '' })(response => {
      if (response?.statusCode == 200) {
        console.log(response?.results)
        setManufacture(response?.results)
      } else {
      }
    })
    getCategoryListingPaginate({ page: 1, limit: 10, search: '' })(response => {
      if (response?.statusCode == 200) {
        console.log(response?.results)
        setCategory(response?.results)
      } else {
      }
    })
  }, [])

  //   useEffect(() => {
  //     if (formik?.values?.category_ids) {
  //         // getSubCategoryListing(formik?.values?.category_ids)((response) => {
  //         //     if (response?.statusCode === 200) {
  //         //         setSubCategory(response?.data?.subSubCategory);
  //         //     } else {

  //         //     }
  //         // });

  //         getSubCategoryListingPaginate({ page: 1, limit: 10, search: '', categoryIds: formik?.values?.category_ids })(response => {
  //             if (response?.statusCode == 200) {
  //                 console.log(response?.results)
  //                 setSubCategory(response?.results)
  //                 // formik.setValues({
  //                 //     ...formik.values,
  //                 //     subcategory_ids: '',
  //                 //     selectedSubCategory: ''
  //                 // });
  //             } else {
  //             }
  //         })
  //     } 
  // }, [formik?.values?.category_ids]);


  console.log(subcategory);
  //
  // useEffect(()=>{


  //   setOfferList(offer.map((li)=>li.value))
  // },[offer])


  console.log(formik.values.vendorIds);
  console.log(offerList);



  return (
    <React.Fragment>
      <Modal
        show={show}
        onHide={handleClose}
        centered
        className="modal_create"
        size="lg"
      >
        <Form onSubmit={formik.handleSubmit}>
          <Modal.Header closeButton>
            {selectedpromocode?.id
              ?
              <Modal.Title>Update Promocode</Modal.Title> : <Modal.Title>Create Promocode</Modal.Title>
            }
          </Modal.Header>
          <Modal.Body>
            <div className="modal_content_wrapper">
              <div className="row">
                <div className="col-lg-6">
                  <Form.Group className="mb-3" controlId="formBasicEmail">
                    <Form.Label>Name</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Enter code name"
                      name="name"
                      value={formik.values?.name}
                      onChange={handleInputChange}
                      isValid={formik.touched.name && !formik.errors.name}
                      isInvalid={formik.touched.name && !!formik.errors.name}
                    />
                    <Form.Control.Feedback type="invalid">
                      {formik.errors.name}
                    </Form.Control.Feedback>
                  </Form.Group>
                </div>
                <div className="col-lg-6">
                  <Form.Group className="mb-3" controlId="formBasicEmail">
                    <Form.Label>Code</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Enter code "
                      name="code"
                      value={formik.values?.code}
                      onChange={handleInputChange}
                      isValid={formik.touched.code && !formik.errors.code}
                      isInvalid={formik.touched.code && !!formik.errors.code}

                    />
                    <Form.Control.Feedback type="invalid">
                      {formik.errors.code}
                    </Form.Control.Feedback>
                  </Form.Group>
                </div>


                {/* ADD: Exclude Vendors Section - Same pattern as brands in CreateManufacturer */}
                <div className="col-lg-12">
                  <Form.Group className="mb-4">
                    <Form.Label className="fw-semibold" style={{ fontSize: "13px" }}>
                      Exclude Vendors
                    </Form.Label>

                    {/* ADD: AsyncSelect component for vendor search and selection */}
                    <AsyncSelect
                      isMulti
                      loadOptions={loadOptionsManufacture}
                      defaultOptions={manufacture}
                      classNamePrefix="select"
                      isClearable={true}
                      placeholder="Search and select vendors to exclude"
                      onChange={onExcludeVendorChange}
                      value={formik.values.selectedExcludeVendors || []}
                      onMenuScrollToBottom={handleExcludeVendorMenuScrollToBottom}
                      noOptionsMessage={() => "Type to search vendors"}
                      styles={{
                        menu: (base) => ({ ...base, zIndex: 9999 }),
                        control: (base) => ({
                          ...base,
                          border: "1px solid #ced4da",
                          borderRadius: "8px",
                          minHeight: "40px",
                          fontSize: "13px",
                        }),
                        valueContainer: (base) => ({
                          ...base,
                          display: "flex",
                          flexWrap: "nowrap",
                          overflowX: "auto",
                          overflowY: "hidden",
                          scrollbarWidth: "none",
                          msOverflowStyle: "none",
                          "::-webkit-scrollbar": {
                            display: "none",
                          },
                        }),
                        input: (base) => ({
                          ...base,
                          minWidth: "80px",
                          flexShrink: 0,
                        }),
                        multiValue: (base) => ({
                          ...base,
                          backgroundColor: "#dc3545", // Red color to indicate exclusion
                          color: "white",
                          borderRadius: "12px",
                          padding: "0 4px",
                          flexShrink: 0,
                        }),
                        multiValueLabel: (base) => ({
                          ...base,
                          color: "white",
                          fontSize: "12px",
                        }),
                        multiValueRemove: (base) => ({
                          ...base,
                          color: "white",
                          ':hover': {
                            backgroundColor: "#c82333",
                            color: "white",
                          },
                        }),
                      }}
                    />



                    {/* ADD: Validation error message */}
                    <div className="invalid-feedbacks mr-2" style={{ color: "#DC3544", fontSize: "12px" }}>
                      {excludeVendorError && "Please check exclude vendors selection"}
                    </div>
                  </Form.Group>
                </div>




                <div className="col-lg-6">
                  <Form.Group className="mb-3" controlId="formBasicEmail">
                    <Form.Label>Description</Form.Label>
                    <Form.Control
                      as="textarea"
                      rows={3}
                      placeholder="Enter Description"
                      name="description"
                      value={formik.values?.description}
                      onChange={handleInputChange}
                      isValid={
                        formik.touched.description && !formik.errors.description
                      }
                      isInvalid={
                        formik.touched.description &&
                        !!formik.errors.description
                      }
                    />
                    <Form.Control.Feedback type="invalid">
                      {formik.errors.description}
                    </Form.Control.Feedback>
                  </Form.Group>
                </div>
                <div className="col-lg-6">
                  <Form.Label>Offer Type</Form.Label>
                  <Form.Select
                    onChange={(e) => {
                      console.log(e);
                      formik.handleChange(e);

                      handleOfferChange(e.target.value)
                    }}

                    name="offerType"
                    defaultValue="Buy and Get Free"
                    value={formik.values.offerType}
                    isInvalid={
                      formik.touched.offerType && formik.errors.offerType
                    }
                    error={formik.errors.offerType}
                  >

                    {/* <option value="Buy and Get Free" selected="Buy and Get Free" >
                    {formik.values.offerType}
                 
                    </option> */}

                    {/* {offerList} */}
                    {offer?.map((item) => (
                      <option key={item?.value} value={item?.value} selected={item?.value === "Buy and Get Free"}>{item?.value}</option>
                    ))}

                  </Form.Select>
                  <Form.Control.Feedback type="invalid">
                    {formik.errors.offerType}
                  </Form.Control.Feedback>
                </div>
                {formik.values.offerType === "Flat Amount on Category or Subcategory" || formik.values.offerType === "Discount in Percentage on Category or Subcategory" ? <></> : <>

                  {user?.userType === "Vendor" ?
                    <>
                      {/* <div className='col-lg-6'>
                      <Form.Label>Vendor</Form.Label>

                      <AsyncSelect
                        
                        // loadOptions={loadOptionsManufacture}
                        // defaultOptions={manufacture}
                        // menuIsOpen={true}
                        classNamePrefix="select"
                        isClearable={true}
                        placeholder={'Search Vendors'}
                        onChange={onManufactureChange}
                        value={formik.values.selectedVendors}
                        theme={(theme) => ({
                          ...theme,
                          borderRadius: "0 10px 10px 10px",
                          colors: {
                            ...theme.colors,
                            primary: '#779be1',
                          },
                        })}
                        styles={customStyles}

                      />
                      <div className='invalid-feedbacks' style={{ color: '#DC3544' }}>{formik.touched.selectedVendors && formik.errors.selectedVendors}</div>

                    </div> */}
                    </>
                    :

                    <div className='col-lg-6'>
                      <Form.Label>Vendors</Form.Label>

                      <AsyncSelect
                        isMulti
                        loadOptions={loadOptionsManufacture}
                        defaultOptions={manufacture}
                        // menuIsOpen={true}
                        classNamePrefix="select"
                        isClearable={true}
                        placeholder={'Search Vendors'}
                        onChange={onManufactureChange}
                        value={formik.values.selectedVendors}
                        theme={(theme) => ({
                          ...theme,
                          borderRadius: "0 10px 10px 10px",
                          colors: {
                            ...theme.colors,
                            primary: '#779be1',
                          },
                        })}
                        styles={customStyles}

                      />
                      <div className='invalid-feedbacks' style={{ color: '#DC3544' }}>{formik.touched.selectedVendors && formik.errors.selectedVendors}</div>

                    </div>
                  }
                </>}

                {formik.values.offerType === "Flat Amount on Minimum Cart Value" &&
                  <>
                    {formik.values.vendors.map((li, index) => (

                      <div def class="accordion accordion accordion-flush" id="accordionFlushExample">


                        <div class="accordion-item">
                          <h2 class="accordion-header" id={`flush-headingOne${index}`}>
                            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target={`#flush-collapseOne${index}`} aria-expanded="false" aria-controls={`flush-collapseOne${index}`}>
                              {li.vendorLabel}
                            </button>
                          </h2>
                          <div id={`flush-collapseOne${index}`} class="accordion-collapse collapse show" aria-labelledby={`flush-headingOne${index}`} data-bs-parent="#accordionFlushExample">
                            <div class="accordion-body">
                              <>
                                <div className="col-lg-6">
                                  <Form.Group className="mb-3" controlId="formBasicEmail">
                                    <Form.Label>Minimum Cart Value</Form.Label>
                                    <Form.Control
                                      type="text"
                                      placeholder="Enter minimum cart value"
                                      name="minimum_cart_value"
                                      value={li.minimum_cart_value}
                                      onChange={(e) => minimumCartvalueHandler(e.target.value, index)}
                                      isValid={formik.touched.minimum_cart_value && !formik.errors.minimum_cart_value}
                                      isInvalid={formik.touched.minimum_cart_value && !!formik.errors.minimum_cart_value}

                                    />
                                    <Form.Control.Feedback type="invalid">
                                      {formik.errors.minimum_cart_value}
                                    </Form.Control.Feedback>
                                  </Form.Group>
                                </div>
                                <div className="col-lg-6">
                                  <Form.Group className="mb-3" controlId="formBasicEmail">
                                    <Form.Label>Amount</Form.Label>
                                    <Form.Control
                                      type="text"
                                      placeholder="Enter amount"
                                      name="amount"
                                      value={li.amount}
                                      onChange={(e) => amountHandler(e.target.value, index)}
                                      // onChange={formik.handleChange}
                                      isValid={formik.touched.amount && !formik.errors.amount}
                                      isInvalid={formik.touched.amount && !!formik.errors.amount}

                                    />
                                    <Form.Control.Feedback type="invalid">
                                      {formik.errors.amount}
                                    </Form.Control.Feedback>
                                  </Form.Group>
                                </div>
                              </>
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                  </>
                }
                {formik.values.offerType === "Discount in Percentage on Minimum Cart Value" &&
                  <>
                    {formik.values.vendors.map((li, index) => (
                      <div class="accordion accordion accordion-flush" id="accordionFlushExample">
                        <div class="accordion-item">
                          <h2 class="accordion-header" id={`flush-headingOne${index}`}>
                            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target={`#flush-collapseOne${index}`} aria-expanded="false" aria-controls={`flush-collapseOne${index}`}>
                              {li.vendorLabel}
                            </button>
                          </h2>
                          <div id={`flush-collapseOne${index}`} class="accordion-collapse collapse show" aria-labelledby={`flush-headingOne${index}`} data-bs-parent="#accordionFlushExample">
                            <div class="accordion-body">
                              <>
                                <div className="col-lg-6">
                                  <Form.Group className="mb-3" controlId="formBasicEmail">
                                    <Form.Label>Minimum Cart Value</Form.Label>
                                    <Form.Control
                                      type="text"
                                      placeholder="Enter minimum cart value"
                                      name="minimum_cart_value"
                                      value={li.minimum_cart_value}
                                      onChange={(e) => minimumCartvalueHandler(e.target.value, index)}
                                      isValid={formik.touched.minimum_cart_value && !formik.errors.minimum_cart_value}
                                      isInvalid={formik.touched.minimum_cart_value && !!formik.errors.minimum_cart_value}

                                    />
                                    <Form.Control.Feedback type="invalid">
                                      {formik.errors.minimum_cart_value}
                                    </Form.Control.Feedback>
                                  </Form.Group>
                                </div>
                                <div className="col-lg-6">
                                  <Form.Group className="mb-3" controlId="formBasicEmail">
                                    <Form.Label>Amount</Form.Label>
                                    <Form.Control
                                      type="text"
                                      placeholder="Enter amount"
                                      name="amount"
                                      value={li.amount}
                                      onChange={(e) => amountHandler(e.target.value, index)}
                                      // onChange={formik.handleChange}
                                      isValid={formik.touched.amount && !formik.errors.amount}
                                      isInvalid={formik.touched.amount && !!formik.errors.amount}

                                    />
                                    <Form.Control.Feedback type="invalid">
                                      {formik.errors.amount}
                                    </Form.Control.Feedback>
                                  </Form.Group>
                                </div>
                              </>
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                  </>
                }

                {formik.values.vendors.length >= 0 && formik.values.offerType === "Buy and Get Free" && (

                  // <>
                  //   <div className="col-lg-6">
                  //     <Form.Label>Buy Quantity</Form.Label>

                  //     <Form.Control
                  //       type="text"
                  //       placeholder="Enter product quantity "
                  //       name="buy_n"
                  //       value={formik.values?.buy_n}
                  //       onChange={formik.handleChange}
                  //       isValid={formik.touched.buy_n && !formik.errors.buy_n}
                  //       isInvalid={formik.touched.buy_n && !!formik.errors.buy_n}

                  //     />

                  //     <Form.Control.Feedback type="invalid">
                  //       {formik.errors.buy_n}
                  //     </Form.Control.Feedback>
                  //   </div>
                  //   <div className="col-lg-6">
                  //     {/* {numberShow===false&& */}
                  //     <>
                  //       <Form.Label>Get Quantity</Form.Label>
                  //       <Form.Control
                  //         type="text"
                  //         placeholder="Enter product quantity "
                  //         name="get_n"

                  //         value={formik.values?.get_n}  
                  //         onChange={formik.handleChange}
                  //         isValid={formik.touched.get_n && !formik.errors.get_n}
                  //         isInvalid={formik.touched.get_n && !!formik.errors.get_n}

                  //       />

                  //       <Form.Control.Feedback type="invalid">
                  //         {formik.errors.get_n}
                  //       </Form.Control.Feedback>
                  //     </>

                  //   </div>
                  //   <div className="col-lg-6">
                  //     <Form.Label>Buy Product</Form.Label>
                  //     <AsyncSelect
                  //     isMulti
                  //       loadOptions={loadOptionsInventory}
                  //       defaultOptions={inventory}
                  //       classNamePrefix="select"
                  //       isClearable={true}
                  //       placeholder={"Search inventory"}
                  //       onChange={onBuyChange}
                  //       // value={formik.values?.selectedProduct}
                  //       value={formik.values.selectedBuyProduct}
                  //       theme={(theme) => ({
                  //         ...theme,
                  //         borderRadius: "0 10px 10px 10px",
                  //         colors: {
                  //           ...theme.colors,
                  //           primary: "#779be1",
                  //         },
                  //       })}
                  //       styles={customStyles}
                  //     />
                  //     <div className='invalid-feedbacks' style={{ color: '#DC3544' }}>{formik.touched.product_id && formik.errors.selectedBuyProduct}</div>

                  //   </div>
                  //   <div className="col-lg-6">
                  //     <Form.Label>Get Product</Form.Label>
                  //     <AsyncSelect
                  //       isMulti
                  //       loadOptions={loadOptionsInventory}
                  //       defaultOptions={inventory}
                  //       classNamePrefix="select"
                  //       isClearable={true}
                  //       placeholder={"Search inventory"}
                  //       onChange={onGetProduct}
                  //       // value={formik.values?.selectedProduct}
                  //       value={formik.values.selectedGetProduct}
                  //       theme={(theme) => ({
                  //         ...theme,
                  //         borderRadius: "0 10px 10px 10px",
                  //         colors: {
                  //           ...theme.colors,
                  //           primary: "#779be1",
                  //         },
                  //       })}
                  //       styles={customStyles}
                  //     />
                  //     <div className='invalid-feedbacks' style={{ color: '#DC3544' }}>{formik.touched.selectedGetProduct && formik.errors.selectedGetProduct}</div>
                  //   </div>

                  // </>
                  <>
                    {formik.values.vendors.map((li, index) => (
                      <div class="accordion accordion accordion-flush" id="accordionFlushExample">
                        {user?.userType === "Vendor" &&
                          <Form.Label>Vendor</Form.Label>
                        }

                        <div class="accordion-item">
                          <h2 class="accordion-header" id={`flush-headingOne${index}`}>
                            <button class="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target={`#flush-collapseOne${index}`} aria-expanded="false" aria-controls={`flush-collapseOne${index}`}>
                              {li.vendorLabel}
                            </button>
                          </h2>
                          <div id={`flush-collapseOne${index}`} class="accordion-collapse collapse show" aria-labelledby={`flush-headingOne${index}`} data-bs-parent="#accordionFlushExample">
                            <div class="accordion-body"> <>
                              <div className="row">
                                <div className="col-lg-6">
                                  <Form.Label>Buy Quantity</Form.Label>

                                  <Form.Control
                                    type="text"
                                    placeholder="Enter product quantity "
                                    // name="buy_n"
                                    value={formik.values?.vendors[index].buy_quantity
                                    }
                                    // value={buyQuantity}
                                    // onChange={(e)=>setBuyQuantity(e.target.value)}
                                    onChange={(e) => onBuyQuantityChange(e.target.value,

                                      index)}


                                    isValid={formik.touched.buy_n && !formik.errors.buy_n}
                                    isInvalid={formik.touched.buy_n && !!formik.errors.buy_n}

                                  />

                                  <Form.Control.Feedback type="invalid">
                                    {formik.errors.buy_n}
                                  </Form.Control.Feedback>
                                </div>
                                <div className="col-lg-6">
                                  {/* {numberShow===false&& */}
                                  <>
                                    <Form.Label>Get Quantity</Form.Label>
                                    <Form.Control
                                      type="text"
                                      placeholder="Enter product quantity "
                                      name="get_n"

                                      value={formik.values?.vendors[index].get_quantity}
                                      // onChange={formik.handleChange}
                                      // onChange={onGetProduct}
                                      onChange={(e) => onGetQuantityChange(e.target.value, index)}
                                      isValid={formik.touched.get_n && !formik.errors.get_n}
                                      isInvalid={formik.touched.get_n && !!formik.errors.get_n}

                                    />

                                    <Form.Control.Feedback type="invalid">
                                      {formik.errors.get_n}
                                    </Form.Control.Feedback>
                                  </>

                                </div>
                              </div>

                              <>
                                {li.items?.map((item, itemIndex) => (
                                  <>
                                    <div className="row">
                                      <div className="col-lg-6">

                                        <Form.Label>Buy Product</Form.Label>
                                        {user?.userType === "Vendor" ? <AsyncSelect

                                          loadOptions={loadOptionsInventory}
                                          defaultOptions={inventory}
                                          classNamePrefix="select"
                                          isClearable={true}
                                          placeholder={"Search inventory"}
                                          onChange={(e) => onBuyChange(e, index, itemIndex)}
                                          // value={formik.values?.selectedProduct}
                                          value={item?.selectedBuyProduct}
                                          theme={(theme) => ({
                                            ...theme,
                                            borderRadius: "0 10px 10px 10px",
                                            colors: {
                                              ...theme.colors,
                                              primary: "#779be1",
                                            },
                                          })}
                                          styles={customStyles}
                                        />
                                          :
                                          <AsyncSelect

                                            loadOptions={loadOptionsInventory}
                                            defaultOptions={onInventory(li.vendorId)}
                                            classNamePrefix="select"
                                            isClearable={true}
                                            placeholder={"Search inventory"}
                                            onChange={(e) => onBuyChange(e, index, itemIndex)}
                                            // value={formik.values?.selectedProduct}
                                            value={item?.selectedBuyProduct}
                                            theme={(theme) => ({
                                              ...theme,
                                              borderRadius: "0 10px 10px 10px",
                                              colors: {
                                                ...theme.colors,
                                                primary: "#779be1",
                                              },
                                            })}
                                            styles={customStyles}
                                          />
                                        }
                                        <div className='invalid-feedbacks' style={{ color: '#DC3544' }}>{formik.touched.selectedBuyProduct && formik.errors.selectedBuyProduct}</div>

                                      </div>

                                      <div className="col-lg-6">

                                        <Form.Label>Get Product</Form.Label>
                                        {user?.userType === "Vendor" ? <AsyncSelect

                                          loadOptions={loadOptionsInventory}
                                          defaultOptions={inventory}
                                          classNamePrefix="select"
                                          isClearable={true}
                                          placeholder={"Search inventory"}
                                          onChange={(e) => onGetProduct(e, index, itemIndex)}
                                          // value={formik.values?.selectedProduct}
                                          value={item?.selectedGetProduct}
                                          theme={(theme) => ({
                                            ...theme,
                                            borderRadius: "0 10px 10px 10px",
                                            colors: {
                                              ...theme.colors,
                                              primary: "#779be1",
                                            },
                                          })}
                                          styles={customStyles}
                                        />
                                          :
                                          <AsyncSelect

                                            loadOptions={loadOptionsInventory}
                                            defaultOptions={onInventory(li.vendorId)}
                                            classNamePrefix="select"
                                            isClearable={true}
                                            placeholder={"Search inventory"}
                                            onChange={(e) => onGetProduct(e, index, itemIndex)}
                                            // value={formik.values?.selectedProduct}
                                            value={item?.selectedGetProduct}
                                            theme={(theme) => ({
                                              ...theme,
                                              borderRadius: "0 10px 10px 10px",
                                              colors: {
                                                ...theme.colors,
                                                primary: "#779be1",
                                              },
                                            })}
                                            styles={customStyles}
                                          />
                                        }
                                        <div className='invalid-feedbacks' style={{ color: '#DC3544' }}>{formik.touched.selectedGetProduct && formik.errors.selectedGetProduct}</div>
                                      </div>
                                    </div>
                                    <IoIosAddCircle style={{ fontSize: "25px", color: "green" }} type="button" onClick={() => addNewItem(index)} />
                                    <IoIosRemoveCircle style={{ fontSize: "25px", color: "red" }} type="button" onClick={(e) => removeItem(e, index, itemIndex)} />

                                  </>
                                ))}

                              </>
                            </></div>
                          </div>
                        </div>
                      </div>
                    ))}
                  </>

                )}

                <>
                  {formik.values.offerType === "Flat Amount on Category or Subcategory" &&
                    <>
                      <div className='col-lg-6'>
                        <Form.Label>Category</Form.Label>
                        <AsyncSelect
                          isMulti
                          loadOptions={loadOptionsCategory}
                          defaultOptions={category}
                          classNamePrefix="select"
                          isClearable={true}
                          placeholder={'Search Categories'}
                          onChange={onCategoryChange}
                          value={formik.values.selectedCategory}
                          theme={(theme) => ({
                            ...theme,
                            borderRadius: "0 10px 10px 10px",
                            colors: {
                              ...theme.colors,
                              primary: '#779be1',
                            },
                          })}
                          styles={customStyles}
                        />

                        <div className='invalid-feedbacks' style={{ color: '#DC3544' }}>{formik.touched.category_ids && formik.errors.category_ids}</div>
                      </div>
                      {formik.values.categories.map((categoryItem, index) => (
                        <div class="accordion accordion accordion-flush" id="accordionFlushExample">
                          <div class="accordion-item">
                            <h2 class="accordion-header" id={`flush-headingOne${index}`}>
                              <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target={`#flush-collapseOne${index}`} aria-expanded="false" aria-controls={`flush-collapseOne${index}`}>
                                {categoryItem.categoryLabel}
                              </button>
                            </h2>
                            <div id={`flush-collapseOne${index}`} class="accordion-collapse collapse show" aria-labelledby={`flush-headingOne${index}`} data-bs-parent="#accordionFlushExample">
                              <div class="accordion-body">
                                {/* {console.log(li,"*********************************")} */}


                                {/* <div className='col-lg-6'>{console.log("==============================",subItem)} */}
                                <Form.Label>Sub-Category</Form.Label>
                                <AsyncSelect
                                  isMulti
                                  loadOptions={(e) => loadOptionsSubCategory(e, categoryItem?.categoryId)}
                                  // defaultOptions={subcategory}
                                  classNamePrefix="select"
                                  isClearable={true}
                                  placeholder={'Search Sub Categories'}
                                  onChange={(e) => onSubCategoryChange(e, index)}
                                  value={categoryItem.selectedSubSubCategories}
                                  theme={(theme) => ({
                                    ...theme,
                                    borderRadius: "0 10px 10px 10px",
                                    colors: {
                                      ...theme.colors,
                                      primary: '#779be1',
                                    },
                                  })}
                                  styles={customStyles}
                                />

                                <div className='invalid-feedbacks' style={{ color: '#DC3544' }}>{formik.touched.sub_category_ids && formik.errors.sub_category_ids}</div>
                              </div>

                            </div>
                          </div>
                        </div>
                        // </div>
                      ))}

                      <div className="col-lg-6">
                        <Form.Group className="mb-3" controlId="formBasicEmail">
                          <Form.Label>Amount</Form.Label>
                          <Form.Control
                            type="text"
                            placeholder="Enter amount"
                            name="amount"
                            value={formik.values?.amount}
                            onChange={(e) => categoryAmountHAndler(e.target.value)}
                            isValid={formik.touched.amount && !formik.errors.amount}
                            isInvalid={formik.touched.amount && !!formik.errors.amount}

                          />
                          <Form.Control.Feedback type="invalid">
                            {formik.errors.amount}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </div>
                    </>
                  }

                  {formik.values.offerType === "Discount in Percentage on Category or Subcategory" &&
                    <>
                      <div className='col-lg-6'>
                        <Form.Label>Category</Form.Label>
                        <AsyncSelect
                          isMulti
                          loadOptions={loadOptionsCategory}
                          defaultOptions={category}
                          classNamePrefix="select"
                          isClearable={true}
                          placeholder={'Search Categories'}
                          onChange={onCategoryChange}
                          value={formik.values.selectedCategory}
                          theme={(theme) => ({
                            ...theme,
                            borderRadius: "0 10px 10px 10px",
                            colors: {
                              ...theme.colors,
                              primary: '#779be1',
                            },
                          })}
                          styles={customStyles}
                        />

                        <div className='invalid-feedbacks' style={{ color: '#DC3544' }}>{formik.touched.category_ids && formik.errors.category_ids}</div>
                      </div>

                      {formik.values.categories.map((categoryItem, index) => (
                        <div class="accordion accordion accordion-flush" id="accordionFlushExample">
                          <div class="accordion-item">
                            <h2 class="accordion-header" id={`flush-headingOne${index}`}>
                              <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target={`#flush-collapseOne${index}`} aria-expanded="false" aria-controls={`flush-collapseOne${index}`}>
                                {categoryItem.categoryLabel}
                              </button>
                            </h2>
                            <div id={`flush-collapseOne${index}`} class="accordion-collapse collapse show" aria-labelledby={`flush-headingOne${index}`} data-bs-parent="#accordionFlushExample">
                              <div class="accordion-body">
                                {/* {console.log(li,"*********************************")} */}


                                {/* <div className='col-lg-6'>{console.log("==============================",subItem)} */}
                                <Form.Label>Sub-Category</Form.Label>
                                <AsyncSelect
                                  isMulti
                                  loadOptions={(e) => loadOptionsSubCategory(e, categoryItem?.categoryId)}
                                  // defaultOptions={subcategory}
                                  classNamePrefix="select"
                                  isClearable={true}
                                  placeholder={'Search Sub Categories'}
                                  onChange={(e) => onSubCategoryChange(e, index)}
                                  value={categoryItem.selectedSubSubCategories}
                                  theme={(theme) => ({
                                    ...theme,
                                    borderRadius: "0 10px 10px 10px",
                                    colors: {
                                      ...theme.colors,
                                      primary: '#779be1',
                                    },
                                  })}
                                  styles={customStyles}
                                />

                                <div className='invalid-feedbacks' style={{ color: '#DC3544' }}>{formik.touched.sub_category_ids && formik.errors.sub_category_ids}</div>
                              </div>

                            </div>
                          </div>
                        </div>
                        // </div>
                      ))}
                      <div className="col-lg-6">
                        <Form.Group className="mb-3" controlId="formBasicEmail">
                          <Form.Label>Amount</Form.Label>
                          <Form.Control
                            type="text"
                            placeholder="Enter amount"
                            name="amount"
                            value={formik.values?.amount}
                            onChange={(e) => categoryAmountHAndler(e.target.value)}
                            isValid={formik.touched.amount && !formik.errors.amount}
                            isInvalid={formik.touched.amount && !!formik.errors.amount}

                          />
                          <Form.Control.Feedback type="invalid">
                            {formik.errors.amount}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </div>
                    </>
                  }
                  {formik.values.offerType === "Free Item on Minimum Cart Value" &&
                    <>
                      {formik.values.freeItems.map((li, index) => (
                        <>
                          <div class="accordion accordion accordion-flush" id="accordionFlushExample">
                            <div class="accordion-item">
                              <h2 class="accordion-header" id={`flush-headingOne${index}`}>
                                <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target={`#flush-collapseOne${index}`} aria-expanded="false" aria-controls={`flush-collapseOne${index}`}>
                                  {li.vendorLabel}
                                </button>
                              </h2>
                              <div id={`flush-collapseOne${index}`} class="accordion-collapse collapse show" aria-labelledby={`flush-headingOne${index}`} data-bs-parent="#accordionFlushExample">
                                <div class="accordion-body">
                                  <div className="col-lg-6">
                                    <Form.Label>Products</Form.Label>
                                    <AsyncSelect

                                      loadOptions={loadOptionsInventory}
                                      defaultOptions={onInventory(li.vendorId)}
                                      classNamePrefix="select"
                                      isClearable={true}
                                      placeholder={"Search inventory"}
                                      onChange={(e) => inventoryChange(e, index)}
                                      // value={formik.values.selectedInventory}
                                      value={li.selectedProduct}
                                      theme={(theme) => ({
                                        ...theme,
                                        borderRadius: "0 10px 10px 10px",
                                        colors: {
                                          ...theme.colors,
                                          primary: "#779be1",
                                        },
                                      })}
                                      styles={customStyles}
                                    />

                                    <div
                                      className="invalid-feedbacks"
                                      style={{ color: "#DC3544" }}
                                    >
                                      <div className='invalid-feedbacks' style={{ color: '#DC3544' }}>{formik.touched.selectedInventory && formik.errors.selectedInventory}</div>

                                    </div>
                                  </div>
                                  <div className="col-lg-6">
                                    <Form.Group className="mb-3" controlId="formBasicEmail">
                                      <Form.Label>Minimum Cart Value</Form.Label>
                                      <Form.Control
                                        type="text"
                                        placeholder="Enter minimum cart value"
                                        name="minimum_cart_value"
                                        value={li.minimum_cart_value}
                                        onChange={(e) => minimumCartonFreeItemHandler(e.target.value, index)}
                                        isValid={formik.touched.minimum_cart_value && !formik.errors.minimum_cart_value}
                                        isInvalid={formik.touched.minimum_cart_value && !!formik.errors.minimum_cart_value}

                                      />
                                      <Form.Control.Feedback type="invalid">
                                        {formik.errors.minimum_cart_value}
                                      </Form.Control.Feedback>
                                    </Form.Group>
                                  </div>

                                </div>
                              </div>
                            </div>
                          </div>
                        </>
                      ))}
                    </>
                  }

                  {/* <div className="col-lg-6">
                  <Form.Group className="mb-3" controlId="formBasicEmail">
                    <Form.Label>Discount</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Amount"
                      name="discount"
                      value={formik.values?.discount}
                      onChange={formik.handleChange}
                      isValid={
                        formik.touched.discount && !formik.errors.discount
                      }
                      isInvalid={
                        formik.touched.discount && !!formik.errors.discount
                      }
                    />
                    <Form.Control.Feedback type="invalid">
                      {formik.errors.discount}
                    </Form.Control.Feedback>
                  </Form.Group>
                </div> */}
                </>
                <div className="col-lg-6">
                  <Form.Group className="">
                    <Form.Label>Expiration Date</Form.Label>
                    <div className="select-container">
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DemoContainer components={["DatePicker"]}>
                          <DatePicker
                            name="expiryDate"

                            value={dayjs(formik.values.expiryDate)}
                            onChange={(newValue) => {
                              const formattedDate =
                                dayjs(newValue).format("YYYY-MM-DD");
                              formik.setFieldValue("expiryDate", formattedDate);
                              onDate(formattedDate)

                              // formik.handleChange("expiryDate", formattedDate);
                            }}

                            format="DD/MM/YYYY"
                            label=""
                            disablePast
                            TextFieldComponent={({ inputRef, ...other }) => (
                              <Form.Control {...other} readOnly />
                            )}
                          />
                        </DemoContainer>
                      </LocalizationProvider>
                      <div className='invalid-feedbacks' style={{ color: '#DC3544' }}>{formik.touched.expiryDate && formik.errors.expiryDate}</div>
                    </div>
                  </Form.Group>
                </div>
                {/* <div className="col-lg-6">
                  <Form.Group className="mb-3" controlId="formBasicEmail">
                    <Form.Label>Usage Limit</Form.Label>
                    <Form.Control
                      type="number"
                      placeholder="Limit"
                      name="usageLimit"
                      value={formik.values?.usageLimit}
                      onChange={formik.handleChange}
                      isValid={
                        formik.touched.usageLimit && !formik.errors.usageLimit
                      }
                      isInvalid={
                        formik.touched.usageLimit && !!formik.errors.usageLimit
                      }
                    />
                    <Form.Control.Feedback type="invalid">
                      {formik.errors.usageLimit}
                    </Form.Control.Feedback>
                  </Form.Group>
                </div> */}
                <div className="col-lg-6">
                  <Form.Group controlId="formFileMultiple" className="mb-3">
                    <Form.Label>Promocode Image</Form.Label>
                    <Form.Control
                      type="file"
                      onChange={handleImageChange}
                      isInvalid={formik.touched.image && formik.errors.image}
                      error={formik.errors.image}
                    />
                    <Form.Control.Feedback type="invalid">{formik.errors.image}</Form.Control.Feedback>
                    {/* {preImage&&
                    <div className="uploaded-images">
                                                            <img src={preImage} alt="product" width={'180px'} height={'180px'} />
                                                        </div>
} */}
                    {formik.values.img_view &&
                      <img src={formik.values.img_view} alt='promocode' className='mb-2' height={150} width={150} />
                    }
                  </Form.Group>
                </div>



                <>

                  {/* <div className="col-lg-6">
                    <div className="status_wrap">
                      <div className="title">Free Delivery</div>
                      <Form.Check
                        type="switch"
                        id="custom-switch"
                        checked={formik.values.freeDelivery}
                        onChange={(e) => formik.handleChange(e)}
                        name="freeDelivery"
                      />
                    </div>
                  </div> */}
                </>

              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button className="cancle_btn" onClick={handleClose}>
              Cancel
            </Button>
            <Button className="submit_btn" type="submit"  >
              {loading
                ? "Loading"
                : selectedpromocode?.id
                  ? "Update Code"
                  : "Create Code"}
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>
    </React.Fragment>
  );
};

export default CreatePromoCodes;
